import request from '@/utils/request'

/**
 * 配置菜单
 * @param {Object} data 请求参数
 * @returns {Promise}
 */
export function configMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.configMenu',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取菜单列表
 * @param {Object} params 请求参数
 * @returns {Promise}
 */
export function listMenus(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.listMenus',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存菜单信息
 * @param {Object} data 请求参数
 * @returns {Promise}
 */
export function updateMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.updateMenu',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.deleteMenu',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}